export type CursorAgentMessage = {
  role: 'user' | 'assistant';
  text: string;
};

const HISTORY_KEY = 'cursorAgent.messages';
/** Keep chat history short for render perf and localStorage size. */
const MAX_MESSAGES = 10;

export function loadCursorAgentHistory(): CursorAgentMessage[] {
  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    const out: CursorAgentMessage[] = [];
    for (const item of parsed) {
      if (
        item &&
        typeof item === 'object' &&
        (item as CursorAgentMessage).role &&
        typeof (item as CursorAgentMessage).text === 'string'
      ) {
        const role = (item as CursorAgentMessage).role;
        if (role !== 'user' && role !== 'assistant') continue;
        const text = (item as CursorAgentMessage).text.trim();
        if (!text) continue;
        out.push({ role, text });
      }
    }
    return out.slice(-MAX_MESSAGES);
  } catch {
    return [];
  }
}

export function saveCursorAgentHistory(messages: CursorAgentMessage[]): void {
  try {
    const trimmed = messages.slice(-MAX_MESSAGES);
    localStorage.setItem(HISTORY_KEY, JSON.stringify(trimmed));
  } catch {
    /* ignore quota */
  }
}

export function clearCursorAgentHistory(): void {
  try {
    localStorage.removeItem(HISTORY_KEY);
  } catch {
    /* ignore */
  }
}
